import { render, staticRenderFns } from "./ChamadasInscricoes.vue?vue&type=template&id=6793071d&scoped=true"
import script from "./ChamadasInscricoes.vue?vue&type=script&lang=js"
export * from "./ChamadasInscricoes.vue?vue&type=script&lang=js"
import style0 from "./ChamadasInscricoes.vue?vue&type=style&index=0&id=6793071d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6793071d",
  null
  
)

export default component.exports